import React, { useState } from 'react';
import { LuEye, LuEyeClosed } from 'react-icons/lu';
import { Input } from './Input';

export const PasswordInput = ({ ...props }) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <Input
      type={showPassword ? 'text' : 'password'}
      icon={
        <button
          type="button"
          onClick={togglePasswordVisibility}
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            padding: '4px'
          }}
          aria-label={showPassword ? 'Ocultar senha' : 'Mostrar senha'}
          tabIndex={-1} // Evita que o toggle receba foco via Tab e atrapalhe o fluxo do formulário
        >
          {showPassword ? <LuEye size={18} /> : <LuEyeClosed size={18} />}
        </button>
      }
      {...props}
    />
  );
};
